import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import './actionLink.scss';

const actionLink = ({
  styleClass,
  redirectTo,
  value,
  handleClick = null,
  anchor = false,
  target = true,
  href = '#',
  disabled=false,
  icon=false,
  isMandatory=false
}) => {
  return (
    <div className={`action-link ${styleClass}`}>
      {anchor ? (
        <a
          className={`user-link  ${icon ? "icon" : ""}`}
          href={href}
          onClick={handleClick}
          {...(target && { target: '_blank' })}
          disabled={disabled}
        >
          {!icon ? `${value}` : null}
          {icon && value === 'Help & Support' ? (<i className="fas fa-question-circle"></i>) : null}
          {icon && value === 'Email Us' ? (<i className="fas fa-envelope"></i>) : null}
          {isMandatory && <sup>*</sup>}
        </a>
      ) : (
        <Link to={redirectTo} className="user-link" onClick={handleClick} disabled={disabled}>
          {value}{isMandatory && <sup>*</sup>}
        </Link>
      )}
    </div>
  );
};

actionLink.propTypes = {
  value: PropTypes.string.isRequired,
  redirectTo: PropTypes.string,
  anchor: PropTypes.bool,
  href: PropTypes.string,
};

export default actionLink;
